import { DirectionsBike, FiberManualRecord } from '@mui/icons-material';
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CurrentPContext, MasterContext, MobiOrNotContext } from "../../ContextApi/context";
import utilsRests from "../../_Utils/utilsRests";
import { getRandomDelay } from './delayManager';

import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import ConnUrls from "../../Connections/ConnectURL";
import MyDateTime from "../../DTechComp/MyDateTime";
import myFunctions from "../../myFunctions";
import { Autoplay } from 'swiper';
import useNotDelivering from '../../DTechComp/useNotDelivering';
import { byPlaceRank } from '../../DTechComp/placeRelevance';

const MainFavs = (props) => {
    const [master] = useContext(MasterContext);
    const notDeliveringTxt = useNotDelivering();

    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [theList] = useState(props.TheList);
    const [mainFavs, setMainFavs] = useState([]);

    useEffect(() => {
        getMRsts();
    }, [])


    const getMRsts = async () => {

        let temp = [];
        for (let i = 0; i < theList.length || 0; i++) {
            temp.push(theList[i]._id);
        }

        let hPage = await utilsRests.getMainRestsByIds(temp);

        let readylist = myFunctions.getShufBuissClosAtLast(hPage, master)
        // מי שלא מגיע לעיר של הלקוח - בסוף (placeRank מהשרת, על הפריטים ב-TheList)
        const rankById = new Map(theList.map(r => [String(r._id), r.placeRank]));
        readylist = byPlaceRank(readylist, (r) => r && rankById.get(String(r._id)));

        setMainFavs(readylist);

    }





    return (

        mainFavs.length > 0 && props.header && <>
            <div className={"spaceRightLong MbigFont bold SecondFont spaceBLockesDown_Minus-10"}>
                {props.header}
            </div>

            <div className={"FourMainLnksDiv"} style={{ direction: "rtl" }}>
                <Swiper
                    reverseDirection={false}
                    spaceBetween={mobiOrNot ? 10 : 16}
                    slidesPerGroup={1}
                    slidesPerView={mobiOrNot ? 3 : 6}
                    loop={false}
                    initialSlide={0}
                    speed={3000}
                    // onSlideChange={() => console.log('slide change')}
                    freeMode={true}
                    loopFillGroupWithBlank={true}
                // autoplay={{
                //     delay: getRandomDelay(),
                //     disableOnInteraction: true
                // }}
                // modules={[Autoplay]}
                >
                    {
                        mainFavs.map((item, index) => {
                            let timing = (item.Delivery?.Time) ? item.Delivery.Time : (item.TakeAway?.Time) ? item.TakeAway.Time : 30;
                            let timingChannel = (item.Delivery?.Time) ? "Deliver" : "Take";
                            timing = myFunctions.checkForDeliverysDelay(master, timing, timingChannel);

                            let priceing = (item.Delivery?.Price) ? item.Delivery.Price : (item.TakeAway?.Price) ? item.TakeAway.Price : 20;

                            let chans = MyDateTime.resolveBusinessChannels(item, master);

                            let notGettinOrders = myFunctions.notGettinOrders(master, item, chans);

                            return (
                                <SwiperSlide key={index} className={mobiOrNot ? "favBtn" : "NotfavBtn"}>
                                    <Link to={`/restaurants/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`}>


                                        <div className={"imgWrap animate__animated pulseME"}>

                                            <div className={"imgDiv mainFavImgDiv"} style={{ backgroundImage: `url("${ConnUrls.media(item.buissMainImg)}")` }} >

                                                {(notGettinOrders != "") ?
                                                    <div data-nosnippet className={"no-render imgWrapDivClose imgWrapDivCloseSmall"}><span>{notGettinOrders}</span></div> : ""}

                                                {/* <div className={"imgDiv mainFavImgDiv"} style={{ backgroundImage: `url("${ConnUrls.media(item.buissMainImg)}")` }} >

                                            </div> */}
                                                <div style={{ position: "relative", bottom: mobiOrNot ? "5px" : "10px" }}>
                                                    <div className={"botBlock"}>
                                                        <div className={"width_90"}>
                                                            <div className={`pgBigTxt dottedLine_2 regularFont bold`}>
                                                                {item.buissName}
                                                            </div>
                                                            <div className={`pgSmallTxt grayText ${(mobiOrNot) ? "mediumst" : "regularFont"}`}>

                                                                <span>{item.buissKitchType}</span>
                                                            </div>
                                                            {/* עסק שלא שולח לעיר שהלקוח בחר */}
                                                            {notDeliveringTxt(item) &&
                                                                <div className={"pgSmallTxt"}><span className={"notDelivTag"}>{notDeliveringTxt(item)}</span></div>}


                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </Link>
                                </SwiperSlide>
                            )
                        })
                    }
                    {[...Array(mobiOrNot ? parseInt(mainFavs.length / 9) + 1 : parseInt(mainFavs.length / 18) + 1)].map((_, i) => (
                        <SwiperSlide key={mainFavs.length + i + 1} className="favBtn spacerfavBtn">
                            <Link to="">
                                <div className="catBtnMasterWrap">
                                    <img className="prodImage" src={""} alt={currentPage.altTags || currentPage.pageName || ""} />
                                </div>
                                <div className="fourMastBtn pointing">{/* Your content here */}</div>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    )
}

export default MainFavs;